import { createSlice } from '@reduxjs/toolkit';

export const statisticsSlice = createSlice({
  name: 'statisticsSlice',
  initialState: {
    selectedPlatform: ['eitaa_channel_post'],
  },
  reducers: {
    toggleSelectedPlatform: (state, action) => {
      if (state.selectedPlatform.length) {
        state.selectedPlatform.pop();
      }
      state.selectedPlatform.push(action.payload);
    },
  },
});

export const { toggleSelectedPlatform } = statisticsSlice.actions;
